import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PositionsTab from "@/pages/admin/hiring/PositionsTab";
import ApplicantsTab from "@/pages/admin/hiring/ApplicantsTab";

export default function Hiring() {
  const [params, setParams] = useSearchParams();
  const [meta, setMeta] = useState(null);
  const [denied, setDenied] = useState("");
  const tab = params.get("tab") === "positions" ? "positions" : "applicants";

  useEffect(() => {
    api.get("/hiring/meta").then(({ data }) => setMeta(data))
      .catch((e) => setDenied(apiError(e.response?.data?.detail)));
  }, []);

  if (denied) return (
    <div data-testid="hiring-denied">
      <h1 className="text-4xl font-bold tracking-tight">Hiring</h1>
      <p className="mt-4 text-muted-foreground max-w-xl">{denied}</p>
    </div>
  );
  if (!meta) return <p className="text-muted-foreground" data-testid="hiring-loading">Loading hiring records…</p>;

  return (
    <div data-testid="hiring-page">
      <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#3B82F6]">Careers and hiring</p>
      <h1 className="mt-3 text-4xl font-bold tracking-tight">Hiring</h1>
      <p className="mt-3 text-muted-foreground max-w-3xl">
        Employment applications are kept entirely separate from child enrollment. Nothing here creates a staff
        account — hiring an applicant starts the usual invitation, which they must accept themselves.
      </p>

      <Tabs value={tab} onValueChange={(v) => setParams(v === "positions" ? { tab: "positions" } : {})} className="mt-8">
        <TabsList data-testid="hiring-tabs">
          <TabsTrigger value="applicants" data-testid="tab-applicants">Applicants</TabsTrigger>
          <TabsTrigger value="positions" data-testid="tab-positions">Positions</TabsTrigger>
        </TabsList>
        <TabsContent value="applicants" className="mt-6"><ApplicantsTab meta={meta} /></TabsContent>
        <TabsContent value="positions" className="mt-6"><PositionsTab meta={meta} /></TabsContent>
      </Tabs>
    </div>
  );
}
